$("#check_all").on('click', function () {
    $('.form-check-input').prop('checked', true);
});

$("#check_del").on('click', function () {
    $('.form-check-input').prop('checked', false);
});

$("#check_23").on('click', function () {
    $('.twenty_three').prop('checked', true);
});

